
import RcDomainObject from "@/domain/common/RcDomainObject.js";
import User from "@/domain/model/user/User.js";
// import StringUtils from '@/utils/StringUtils.js';
import Company from "../../company/Company";
import Employee from "../../employee/Employee";
import AiPromptMap from "./AiPromptMap";

export default class AiPrompt extends RcDomainObject {

  static MODEL_NAME = "AiPrompt";

  constructor(domain, data) {
    super(domain, data, AiPrompt.MODEL_NAME);
  }

  static Fields = {
    PROMPT: "prompt",
    RESPONSE: "response",
    COMPANY: "Company",
    EMPLOYEE: "Employee",
    LIKED: "liked"
  }

  fields() {
    return AiPrompt.Fields;
  }

  copy() {
    var data = this._copy();
    return new AiPrompt(this.domain, data);
  }

  find() {
    var promptDomain = this.domain.prompt();
    var item = promptDomain.findById(this.id());
    return item;
  }

  prompt() {
    return this.getString(AiPrompt.Fields.PROMPT);
  }

  withPrompt(name) {
    this.put(AiPrompt.Fields.PROMPT, name);
    return this;
  }

  withResponse(value) {
    this.put(AiPrompt.Fields.RESPONSE, value);
    return this;
  }

  response() {
    return this.getString(AiPrompt.Fields.RESPONSE);
  }

  withCompany(parent) {
    this.put(AiPrompt.Fields.COMPANY, parent.id());
    return this;
  }

  company() {
    return new Company(this.domain, this.get(AiPrompt.Fields.COMPANY));
  }

  withEmployee(parent) {
    this.put(AiPrompt.Fields.EMPLOYEE, parent.id());
    return this;
  }

  employee() {
    return new Employee(this.domain, this.get(AiPrompt.Fields.EMPLOYEE));
  }

  withLiked(count) {
    this.put(AiPrompt.Fields.LIKED, count);
    return this;
  }

  liked() {
    return this.getInt(AiPrompt.Fields.LIKED);
  }

  map() {
    const map = new AiPromptMap(this.domain);
    map.addPrompt(this);
    return map;
  }

  modifiedBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.MODIFIED_BY));
  }

  createdBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.CREATED_BY));
  }

  pointer() {
    var item = new AiPrompt(this.domain);
    item.withId(this.id());
    return item;
  }
}